// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"_c7e6719","small":"_5d5b219"};